import { ReactElement } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import CompanyInfoPage from "./CompanyInfo";
import PasswordPage from "./Password";
import Features from "./CompanyInfo/Features";
import "./styles.css";
import Menu from "./Menu";
import { MenuOption } from "./types";
import { checkPrivilege } from "@utils/helpers";
import { Privileges, AccessLevels } from "../../../types";
import useWhoAmI from "./api/useWhoAmI";
import useFlags from "@common/hooks/useFlags";

type MenuOptionConfig = {
  path: string;
  label: string;
  element: ReactElement;
  privilege?: Privileges;
  accessLevel?: AccessLevels;
  enabled?: boolean;
};

const EditAccount = (): JSX.Element => {
  const { data: user, error, isLoading } = useWhoAmI();
  const { releaseUserFlagManagement } = useFlags();
  if (isLoading || !user || error) {
    return <></>;
  }

  const { privileges } = user.attributes;

  const menuOptionsMap: Record<MenuOption, MenuOptionConfig> = {
    [MenuOption.Contact]: {
      path: "contact",
      label: "Personal Info",
      element: <CompanyInfoPage />,
    },
    [MenuOption.Preferences]: {
      path: "preferences",
      label: "Preferences",
      element: <Features />,
      enabled: releaseUserFlagManagement,
    },
    [MenuOption.Password]: {
      path: "password",
      label: "Password",
      element: <PasswordPage />,
    },
  };

  const menuOptions = Object.entries(menuOptionsMap)
    .filter(([option]) => {
      const { privilege, accessLevel, enabled } = menuOptionsMap[option];
      return (
        enabled !== false &&
        (!privilege ||
          checkPrivilege({
            userPrivileges: privileges || [],
            privilege,
            accessLevel,
          }))
      );
    })
    .map(([option]) => option as MenuOption);

  const menuItems = menuOptions.map((option) => ({
    eventKey: menuOptionsMap[option].path.replace(/\/\*$/, ""),
    label: menuOptionsMap[option].label,
  }));

  return (
    <>
      <Row className="myAccount">
        <Col
          sm={3}
          className="left-menu4"
          style={{ padding: "20px 0px 0px 46px", maxWidth: "20%" }}
        >
          <Menu items={menuItems} />
        </Col>

        <Col sm={9} style={{ padding: "25px 0px 0px" }}>
          <div className="tabContent">
            <Routes>
              {menuOptions.map((option) => {
                const config = menuOptionsMap[option];
                return (
                  <Route
                    key={option}
                    path={config.path}
                    element={config.element}
                  />
                );
              })}
              <Route
                index
                element={
                  <Navigate to={menuOptionsMap[menuOptions[0]].path} replace />
                }
              />
              <Route path="*" element={<div>Page not found</div>} />
            </Routes>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default EditAccount;
